<div class="flex flex-col w-full gap-4 md:gap-6">
  <div class="flex w-full justify-end max-md:justify-center">
    <proffeo-ui-button
      (clicked)="onCreate()"
      [text]="'cooperations.create' | translate"
      variant="accent"
      class="w-full max-md:w-full md:w-auto"
    ></proffeo-ui-button>
  </div>

  <div class="flex flex-col gap-4 w-full md:flex-row">
    <section
      [proffeoSpinner]="incoming() === undefined"
      proffeoSpinnerSize="xl"
      class="flex min-h-48 flex-1 flex-col gap-2 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface p-4 max-sm:px-2 max-md:p-3"
    >
      <h2 class="text-lg text-proffeo-text max-md:text-base">
        {{ 'cooperations.incoming' | translate }}
      </h2>
      @if (incoming()?.length === 0) {
        <p class="text-sm text-proffeo-muted">{{ 'cooperations.no-incoming' | translate }}</p>
      } @else if (incoming(); as items) {
        <ul class="flex flex-col gap-1">
          @for (c of items; track c.id) {
            <li>
              <proffeo-company-cooperations-list-item
                [cooperation]="c"
                [companyId]="companyId()"
                type="incoming"
              ></proffeo-company-cooperations-list-item>
            </li>
          }
        </ul>
      }
    </section>

    <section
      [proffeoSpinner]="outgoing() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 flex-1 flex-col gap-2 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface p-4 max-sm:px-2 max-md:p-3"
    >
      <h2 class="text-lg text-proffeo-text max-md:text-base">
        {{ 'cooperations.outgoing' | translate }}
      </h2>
      @if (outgoing()?.length === 0) {
        <p class="text-sm text-proffeo-muted">{{ 'cooperations.no-outgoing' | translate }}</p>
      } @else if (outgoing(); as items) {
        <ul class="flex flex-col gap-1">
          @for (c of items; track c.id) {
            <li>
              <proffeo-company-cooperations-list-item
                [cooperation]="c"
                [companyId]="companyId()"
                type="outgoing"
              ></proffeo-company-cooperations-list-item>
            </li>
          }
        </ul>
      }
    </section>
  </div>
</div>
